export default function Pagination({ page, total, perPage, onPage, onPerPage, perPageOptions = [20, 50, 100] }) {
  const pages = Math.max(1, Math.ceil(total / perPage));
  const start = total === 0 ? 0 : (page - 1) * perPage + 1;
  const end = Math.min(total, page * perPage);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-line px-4 py-3">
      <p className="text-xs text-content-muted">
        Showing <b>{start}</b>–<b>{end}</b> of <b>{total}</b> records
      </p>
      <div className="flex items-center gap-2">
        <select className="input !w-auto !py-1 text-xs" value={perPage} onChange={(e) => onPerPage(Number(e.target.value))}>
          {perPageOptions.map((n) => (
            <option key={n} value={n}>
              {n} / page
            </option>
          ))}
        </select>
        <button className="btn-outline !px-3 !py-1 text-xs" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          ‹ Prev
        </button>
        <span className="text-xs font-semibold text-content-muted">
          Page {page} / {pages}
        </span>
        <button className="btn-outline !px-3 !py-1 text-xs" disabled={page >= pages} onClick={() => onPage(page + 1)}>
          Next ›
        </button>
      </div>
    </div>
  );
}